import script from "./konaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./konaTable.vue?vue&type=script&setup=true&lang=js"

import "./konaTable.vue?vue&type=style&index=0&id=0592530c&lang=css"
import "./konaTable.vue?vue&type=style&index=1&id=0592530c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0592530c"]])

export default __exports__